module.exports = __webpack_public_path__ + "static/media/LockandKey.acd1ff5e.jpg";